import { TimelineMax, TweenMax, Power1 } from 'gsap/TweenMax';
import selectors from '@/scripts/animation/animation-selectors';

function getAssets(section) {
  return {
    elements: Array.from(section.querySelectorAll(selectors.fadeInUpText)),
  };
}

export default {
  trigger: selectors.fadeInUpText,
  set() {
    const { elements } = getAssets(this.section);
    return TweenMax.set(elements, { autoAlpha: 0 });
  },

  animate() {
    const { elements } = getAssets(this.section);
    const tl = new TimelineMax();
    return tl
      .staggerFromTo(
        elements, selectors.duration * 1.5,
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          ease: Power1.easeIn,
        },
        selectors.delay.stagger, selectors.delay.stage_4,
      )
      .staggerFromTo(
        elements, selectors.duration * 1.5,
        { y: 50, scaleY: 1.3, transformOrigin: 'top center' },
        {
          y: 0,
          scaleY: 1,
          clearProps: 'all',
        },
        selectors.delay.stagger, selectors.delay.stage_4,
      );
  },
};



// WEBPACK FOOTER //
// ./scripts/animation/elements/fade-in-up_text.js